import { render, staticRenderFns } from "./CFlashMessage.vue?vue&type=template&id=5be2a81e&"
import script from "./CFlashMessage.vue?vue&type=script&lang=ts&"
export * from "./CFlashMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports